module.exports = "<div style=\"display:none;\">\n  <ul id=\"images\">\n  </ul>\n</div>"